import React from 'react'
import styled from 'styled-components'
import { breakpoint } from '../layout/styles'
import { useMediaQuery } from '../helpers/mq'

const ResponsiveImage = ({ data }: any) => {
  const desktop = useMediaQuery(breakpoint.desktop)
  const { url } = data[`${desktop ? 'large' : 'small'}_devices`]
  return (
    <Container>
      <img
        src={`${url}?width=1440&auto=webp&quality=75`}
        srcSet={`${url}?width=1440&dpr=2&auto=webp&quality=75 2x`}
      />
    </Container>
  )
}

export default ResponsiveImage

const Container = styled.div`
  padding: 1.5rem;
  @media ${breakpoint.desktop} {
    padding: 0;
    margin: 4rem 0;
  }
  img {
    width: 100%;
  }
`
